package br.com.texeratx.boardgametimeapp.core.spotify.api

import br.com.texeratx.boardgametimeapp.core.spotify.auth.SpotifyAuthManager
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.ClientRequestException
import io.ktor.client.request.get
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode

class SpotifyApi(
    private val http: HttpClient,
    private val auth: SpotifyAuthManager
) {
    suspend fun getMe(): Result<SpotifyMeResponse> = runCatching {
        // 1) pega um access token válido (ou tenta refresh se expirou)
        val token = auth.getValidAccessTokenOrNull()
            ?: error("Spotify não conectado (sem token)")

        // 2) tenta chamar /me
        try {
            http.get("https://api.spotify.com/v1/me") {
                headers.append(HttpHeaders.Authorization, "Bearer $token")
            }.body<SpotifyMeResponse>()
        } catch (e: ClientRequestException) {
            // Se deu 401, tenta refresh e tenta 1 vez de novo
            if (e.response.status == HttpStatusCode.Unauthorized) {
                val refreshed = auth.forceRefreshTokenOrNull()
                    ?: throw e

                http.get("https://api.spotify.com/v1/me") {
                    headers.append(HttpHeaders.Authorization, "Bearer $refreshed")
                }.body<SpotifyMeResponse>()
            } else {
                throw e
            }
        }
    }
}
